import {
  ActionReducerMap,
  MetaReducer,
  createFeatureSelector
} from '@ngrx/store';
import { environment } from '../../../../environments/environment';

import * as fromMenu from './menu.reducer';
import * as fromSidebar from './sidebar.reducer';
import * as fromParameters from './parameters.reducer';

export const sharedFeatureKey = 'shared';

export interface FeatureState {
  [fromMenu.menuFeatureKey]: fromMenu.MenuState;
  [fromSidebar.sidebarFeatureKey]: fromSidebar.SidebarState;
  [fromParameters.parametersFeatureKey]: fromParameters.State;
}

export const reducers: ActionReducerMap<FeatureState> = {
  [fromMenu.menuFeatureKey]: fromMenu.reducer,
  [fromSidebar.sidebarFeatureKey]: fromSidebar.reducer,
  [fromParameters.parametersFeatureKey]: fromParameters.reducer,
};

export const metaReducers: MetaReducer<FeatureState>[] = !environment.production ? [] : [];

export const featureSelector = createFeatureSelector(sharedFeatureKey);
